import Button from "@components/Button";
import { Row } from "@components/Layout";
import useI18n from "@contexts/I18nProvider/hooks/useI18n";
import { Show, type VoidComponent, batch, createSignal } from "solid-js";
import type { SetStoreFunction } from "solid-js/store";
import AdvancedMode from "./components/AdvancedMode";
import ModeSelect from "./components/ModeSelect";
import type { TTSLanguage } from "./components/ModeSelect/types";
import SimpleMode from "./components/SimpleMode";
import type { TTSBlock } from "./types";

const TTSEditor: VoidComponent<{
	blocks: TTSBlock[];
	setTTSBlocks: SetStoreFunction<TTSBlock[]>;
	maxLimit: number;
	minLimit: number;
}> = (props) => {
	const { t, locale } = useI18n();
	const [picked, setPicked] = createSignal(false);
	const [language, setLanguage] = createSignal<TTSLanguage>(locale());
	const [advancedMode, setAdvancedMode] = createSignal(false);

	const handleChangeMode = () => {
		if (advancedMode()) {
			props.setTTSBlocks([props.blocks[0]]);
		}
		setAdvancedMode((s) => !s);
	};

	return (
		<Show
			when={picked()}
			fallback={
				<ModeSelect
					onPick={(a) =>
						batch(() => {
							setAdvancedMode(a ?? false);
							setPicked(true);
						})
					}
					setTTSBlocks={props.setTTSBlocks}
					language={language()}
					setLanguage={setLanguage}
				/>
			}
		>
			<Row padding="0 0 15px" justifyContent="flex-end">
				<Button onclick={handleChangeMode}>
					<Show when={advancedMode()} fallback={t("app.tts.advanced")}>
						{t("app.tts.simple")}
					</Show>
				</Button>
			</Row>
			<Show
				when={advancedMode()}
				fallback={
					<SimpleMode
						setTTSBlocks={props.setTTSBlocks}
						blocks={props.blocks}
						language={language()}
						maxLimit={props.maxLimit}
						minLimit={props.minLimit}
					/>
				}
			>
				<AdvancedMode
					blocks={props.blocks}
					setTTSBlocks={props.setTTSBlocks}
					language={language()}
					limit={props.maxLimit}
				/>
			</Show>
		</Show>
	);
};
export default TTSEditor;
